import {Controller} from "@hotwired/stimulus"
import {replaceFragments} from "../../lib/replace_fragments"

export default class extends Controller {

    static targets = ['wrapper']

    link(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const method = e.currentTarget.dataset.method || 'GET'

        fetch(e.currentTarget.href, {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.text())
            .then(html => {
                this.element.outerHTML = html
            })
    }

    children(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const method = e.currentTarget.dataset.method || 'GET'
        const url = e.currentTarget.dataset.url
        const parameter_name = e.currentTarget.dataset.parameterName || 'id'
        const parameter_value = e.target.value

        const replaceUrl = e.currentTarget.dataset.replaceUrl || 'false'
        const hrefUrl = (replaceUrl == 'true') ? new URL(e.currentTarget.href, window.location.origin) : ""

        const urlWithParams = new URL(url, window.location.origin)
        urlWithParams.searchParams.append(parameter_name, parameter_value)

        fetch(urlWithParams, {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        }).then(response => response.text())
            .then(html => {
                this.wrapperTarget.innerHTML = html
            }).then(() => {
                if  (replaceUrl == 'true') {
                    window.history.replaceState({}, '', hrefUrl)
                }
            })
    }

    clearWrapper(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.wrapperTarget.innerHTML = ''

        const replaceUrl = e.currentTarget.dataset.replaceUrl || 'false'
        if (replaceUrl == 'true') {
            const hrefUrl = new URL(e.currentTarget.href, window.location.origin)
            window.history.replaceState({}, '', hrefUrl)
        }
    }

    form(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        let form = e.currentTarget.form

        return fetch(form.action, {
            method: form.method,
            body: $(form).serialize(),
            credentials: "same-origin",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/x-www-form-urlencoded",
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.text())
            .then(html => {
                this.element.outerHTML = html
            })
    }

    // Like form(), for a save that settles more of the page than the element it replaces.
    // A response with no templates in it behaves exactly like form(), which is what an
    // error comes back as.
    formWithFragments(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        let form = e.currentTarget.form

        return fetch(form.action, {
            method: form.method,
            body: $(form).serialize(),
            credentials: "same-origin",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/x-www-form-urlencoded",
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.text())
            .then(html => {
                this.element.outerHTML = replaceFragments(html)
            })
    }

    formWithRedirect(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        let form = e.currentTarget.form;

        fetch(form.action, {
            method: form.method,
            body: $(form).serialize(),
            credentials: "same-origin",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/x-www-form-urlencoded",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.text()).then(html => {
                if (html.includes("Turbolinks.visit")) {
                    const urlMatch = html.match(/Turbolinks\.visit\(["'](.*?)["']/);
                    if (urlMatch && urlMatch[1]) {
                        Turbolinks.clearCache();
                        Turbolinks.visit(urlMatch[1], { action: "replace" });
                    }
                } else {
                    this.element.outerHTML = html;
                }
            })
    }

  formTask(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    let form = e.currentTarget.form

    return fetch(form.action, {
      method: form.method,
      body: $(form).serialize(),
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded",
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const modal = doc.querySelector('.task-management-modal');
          const table = doc.querySelector('.tables-wrapper')

          if (modal && table) {
              const newContentModal = modal.innerHTML;
              const newContentTable = table.innerHTML;
              if(newContentModal)
                document.querySelector('.task-management-modal').innerHTML = newContentModal;
              if(newContentTable)
                document.querySelector('.tables-wrapper').innerHTML = newContentTable;
              setSortableValues();
              setPredefinedFunctionalities();
          }

          let event = new CustomEvent('taskFormLoaded');
          document.dispatchEvent(event);
        });
  }

  setSortableValues() {
    $(".sortable").sortable({
      axis: "y",
      items: ".sortable-item",
      handle: ".sortable-handle",
      update: function(event, ui) {
        var sortedData = $(this).sortable('serialize');
        $.post($(this).data("sortable-url"), sortedData);
      }
    }).disableSelection();
  }

}
